import { render, staticRenderFns } from "./ScreenNewModal.vue?vue&type=template&id=0b5cfc47&"
import script from "./ScreenNewModal.vue?vue&type=script&lang=js&"
export * from "./ScreenNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports